export default function useMedia() {
  // 状态选项
  const approvalOptions = [
    {
      value: null,
      label: '全部状态',
      alias: '温馨提示',
      statusClass: 'sty-1',
      tip: '我们将在1-3个工作日内完成审核，如审核未通过或发布未成功，已扣除的条数将返回至您的账户中。',
    },
    {
      value: 0,
      label: '待审核',
      alias: '审核中',
      spot: 1,
      statusClass: 'sty-1',
      tip: '我们将在1~3个工作日内完成审核，请耐心等待',
    },
    {
      value: 2,
      label: '已发布',
      alias: '已完成',
      statusClass: 'sty-3',
      tip: '媒体发布的结果已全部更新',
    },
    { value: -1, label: '已驳回', spot: 3, statusClass: 'sty-2' },
    { value: 1, label: '发布中', spot: 0, statusClass: 'sty-1', tip: '加急发布中，请关注发布结果' },
    // { value: 3, label: '发布中', spot: 0, statusClass: 'sty-1', tip: '加急发布中，请关注发布结果' }, // 审核通过，平台暂无结果
    { value: 3, label: '部分驳回', spot: 0, statusClass: 'sty-1' },
  ]

  function getStatus(status: any) {
    const s = Number.isInteger(status) ? status : null
    const approval = approvalOptions.find(item => item.value === s)
    return approval
  }

  return {
    approvalOptions,
    getStatus,
  }
}
